import { CSSProperties, ReactNode } from 'react';
import { AccountTabTabWrapper, AccountTabTabWrapperNoHover } from './style';

interface IProps {
  selected: boolean;
  onClick: () => void;
  icon?: ReactNode;
  label: ReactNode;
  endIcon?: ReactNode;
  style?: CSSProperties;
  showHoverOnLabelsOnly?: boolean;
}

const AccountTabTab = ({
  selected,
  onClick,
  icon,
  label,
  endIcon,
  style,
  showHoverOnLabelsOnly = false,
}: IProps) => {
  return showHoverOnLabelsOnly ? (
    <AccountTabTabWrapperNoHover
      onClick={onClick}
      className={selected ? 'selected' : ''}
      style={style}
    >
      {icon && <span className="shrink-0">{icon}</span>}
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {endIcon && <span className="shrink-0">{endIcon}</span>}
    </AccountTabTabWrapperNoHover>
  ) : (
    <AccountTabTabWrapper
      onClick={onClick}
      className={selected ? 'selected' : ''}
      style={style}
    >
      {icon && (
        <span className="shrink-0 grid place-content-center">{icon}</span>
      )}
      <span className="min-w-0 flex-1 truncate">{label}</span>
      {endIcon && (
        <span className="shrink-0 grid place-content-center">{endIcon}</span>
      )}
    </AccountTabTabWrapper>
  );
};

export default AccountTabTab;
